export enum CasesViewMode {
	TREE = 'TREE',
	LIST = 'LIST',
}
